/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TrackItDataTypeDoubleDto } from './TrackItDataTypeDoubleDto';
import {
    instanceOfTrackItDataTypeDoubleDto,
    TrackItDataTypeDoubleDtoFromJSON,
    TrackItDataTypeDoubleDtoFromJSONTyped,
    TrackItDataTypeDoubleDtoToJSON,
} from './TrackItDataTypeDoubleDto';
import type { TrackItDataTypeLongDto } from './TrackItDataTypeLongDto';
import {
    instanceOfTrackItDataTypeLongDto,
    TrackItDataTypeLongDtoFromJSON,
    TrackItDataTypeLongDtoFromJSONTyped,
    TrackItDataTypeLongDtoToJSON,
} from './TrackItDataTypeLongDto';

/**
 * @type NumericTrackItDataTypeDto
 * 
 * @export
 */
export type NumericTrackItDataTypeDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataTypeDoubleDto, Ptw.Ptw100.AppZero.Application.Shared' } & TrackItDataTypeDoubleDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataTypeLongDto, Ptw.Ptw100.AppZero.Application.Shared' } & TrackItDataTypeLongDto;


export function NumericTrackItDataTypeDtoFromJSON(json: any): NumericTrackItDataTypeDto {
    return NumericTrackItDataTypeDtoFromJSONTyped(json, false);
}

export function NumericTrackItDataTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumericTrackItDataTypeDto {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataTypeDoubleDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, TrackItDataTypeDoubleDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataTypeDoubleDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataTypeLongDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, TrackItDataTypeLongDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataTypeLongDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        default:
            throw new Error(`No variant of NumericTrackItDataTypeDto exists with '$type=${json['$type']}'`);
    }
}

export function NumericTrackItDataTypeDtoToJSON(value?: NumericTrackItDataTypeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataTypeDoubleDto, Ptw.Ptw100.AppZero.Application.Shared':
            return TrackItDataTypeDoubleDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataTypeLongDto, Ptw.Ptw100.AppZero.Application.Shared':
            return TrackItDataTypeLongDtoToJSON(value);
        default:
            throw new Error(`No variant of NumericTrackItDataTypeDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the NumericTrackItDataTypeDto interface.
 */
export function instanceOfNumericTrackItDataTypeDto(value: any): value is NumericTrackItDataTypeDto {
    if (instanceOfTrackItDataTypeDoubleDto(value)) return true;
    if (instanceOfTrackItDataTypeLongDto(value)) return true;
    return false;
}

